import styled from 'styled-components'

export const UserName = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  border-bottom: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'lastItem' does not exist on type 'Themed... Remove this comment to see the full error message
    props.lastItem ? 'none' : `1px solid var(--color-border-subtle)`};
  padding: 12px 24px;
`

export const Link = styled.a`
  margin-left: auto;
  cursor: pointer;
  color: inherit;
  display: flex;
`
